import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { styled } from "@mui/material/styles"
import Stack from "@mui/material/Stack"
import { useAuth } from "context/AuthContext"
import { useRemoveFollowerMutation } from "appRedux/slices/userApiSlice"
import CancelIcon from "components/atoms/_icons/CancelIcon"
import CircularProgress from "components/atoms/CircularProgress"
import Dialog from "components/atoms/Dialog"
import FollowButton from "components/molecules/FollowButton"
import WarningRoundedIcon from "components/atoms/_icons/WarningRoundedIcon"

type ActionButtonsProps = {
  user: UserFollowDto;
  showFollowButton?: boolean;
  showRemoveFollowerButton?: boolean;
  onFollowerRemove?: (id: number) => void;
}
export default function ActionButtons(props: ActionButtonsProps) {
  const { user, showFollowButton, showRemoveFollowerButton, onFollowerRemove = new Function() } = props

  const [showRemoveFollowerConfirmationDialog, setShowRemoveFollowerConfirmationDialog] = useState<boolean>(false)

  const { user: loggedInUser } = useAuth()

  const [triggerRemoveFollower, {
    isLoading: isRemoveFollowerLoading,
    isSuccess: followerRemoved
  }] = useRemoveFollowerMutation()

  const { t } = useTranslation()

  useEffect(() => {
    if (followerRemoved) {
      onFollowerRemove(user.id)
    }
  }, [followerRemoved])

  function onRemoveFollowerButtonClicked() {
    setShowRemoveFollowerConfirmationDialog(true)
  }

  function handleRemoveFollower() {
    triggerRemoveFollower(user.id)
  }

  function handleCloseRemoveFollowerConfirmationDialog() {
    setShowRemoveFollowerConfirmationDialog(false)
  }

  return (
    <>
      <ActionsContainer>
        {(showFollowButton && user.followStatus && loggedInUser?.handle !== user?.handle) && <FollowButton
            userId={user?.id}
            handle={user?.handle}
            status={user?.followStatus}
        />}
        {showRemoveFollowerButton &&
            <Stack justifyContent="center" alignItems="center" onClick={onRemoveFollowerButtonClicked}>
              {isRemoveFollowerLoading ? <CircularProgress/> : <CancelIcon/>}
            </Stack>}
      </ActionsContainer>
      <Dialog
        message={t("connections.removeFollowerConfirmationQuestion", { handle: user?.handle })}
        icon={<WarningRoundedIcon/>}
        buttons={[
          {
            label: t("general.yes"),
            mode: "white",
            loading: isRemoveFollowerLoading,
            onClick: handleRemoveFollower
          },
          {
            label: t("general.no"),
            mode: "primary",
            loading: false,
            onClick: handleCloseRemoveFollowerConfirmationDialog
          }
        ]}
        open={showRemoveFollowerConfirmationDialog}
        onClose={handleCloseRemoveFollowerConfirmationDialog}
      />
    </>
  )
}

const ActionsContainer = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  gap: "8px",

  "& svg": {
    width: "20px",
    height: "20px"
  }
}))
